import { useEffect } from "react";

const VideoModal = ({ videoUrl, posterUrl, onClose }) => {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="modal-video"
      role="dialog"
      aria-label="Video player"
      onClick={onClose}
    >
      <div className="modal-video-body">
        <div className="modal-video-inner">
          <div
            className="modal-video-movie-wrap"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-video-close-btn"
              aria-label="Close video"
              onClick={onClose}
            />
            <video
              src={videoUrl}
              poster={posterUrl}
              controls
              autoPlay
              playsInline
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "#000",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
